// extracted by mini-css-extract-plugin
module.exports = {"loader":"LoaderCircle_loader__1hXiY"};